const types = {
    SAVE_PARAMS: 'notice/SAVE_PARAMS',
    SAVE_SEARCHPARAMS: 'notice/SAVE_SEARCHPARAMS',
};

export const saveParams = params => ({
    type: types.SAVE_PARAMS,
    params,
});

export const saveSearchParams = params => ({
    type: types.SAVE_SEARCHPARAMS,
    params,
});

const initState = {
    params: {},
    searchParams: {},
};

const noticeReducer = (state = initState, actions) => {
    switch(actions.type) {
        case types.SAVE_PARAMS:
            return {
                ...state,
                params: {
                    ...state.params,
                    ...actions.params,
                },
            };
        case types.SAVE_SEARCHPARAMS:
            return {
                ...state,
                searchParams: {
                    ...state.searchParams,
                    ...actions.params,
                },
            };
        default:
            return state;
    }
}

export default noticeReducer;


// WEBPACK FOOTER //
// ./src/actions/noticeActions.js